import { motion } from "framer-motion";
import { fadeUp, viewport } from "@/lib/motion";
import { SERVICES } from "@/lib/data";

export const Services = () => {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-36 bg-[hsl(var(--muted)/0.4)]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl mb-16 md:mb-20">
          <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport}
            className="text-xs font-semibold tracking-[0.25em] uppercase text-gold mb-6">Our Services</motion.p>
          <motion.h2 variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} custom={1}
            className="font-serif font-light text-4xl sm:text-5xl leading-tight text-primary">
            Comprehensive support, from formation to funding.
          </motion.h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 border-l border-t border-border">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div key={s.title} data-testid={`service-card-${i}`}
                variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} custom={i % 3}
                className="group relative p-8 md:p-10 border-r border-b border-border bg-background hover:bg-navy transition-colors duration-500">
                <Icon className="text-gold mb-6" size={26} strokeWidth={1.4} />
                <h3 className="font-serif text-2xl font-normal text-primary group-hover:text-[hsl(var(--background))] transition-colors duration-500 mb-3">
                  {s.title}
                </h3>
                <p className="text-sm font-light leading-relaxed text-muted-foreground group-hover:text-[hsl(var(--background)/0.8)] transition-colors duration-500">
                  {s.desc}
                </p>
              </motion.div>
            );
          })}
        </div>

        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport}
          className="mt-14 flex flex-col sm:flex-row items-start sm:items-center gap-6 justify-between">
          <p className="font-serif text-2xl md:text-3xl font-light italic text-primary">Let's build your funding strategy.</p>
          <button data-testid="services-cta-btn" onClick={() => scrollTo("#contact")}
            className="rounded-full bg-primary text-primary-foreground px-7 py-4 text-sm hover:bg-[hsl(var(--gold))] hover:text-primary transition-colors duration-300 whitespace-nowrap">
            Contact Us
          </button>
        </motion.div>
      </div>
    </section>
  );
};
